export default "__VITE_ASSET__B2NXzuLc__"